var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2, 2)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 7,
    x2: 0,
    y2: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 7,
    x2: 20,
    y2: 13,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 8,
    x2: 5,
    y2: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: 8,
    x2: 10,
    y2: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: 8,
    x2: 15,
    y2: 12,
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScale);
export default __webpack_public_path__ + "static/media/scale.e80826d0127a0f1f4de75ca2999b4522.svg";
export { ForwardRef as ReactComponent };